<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <DefaultTmpl :mode="$appUtils.isMobile() ? 'mobile_search' : 'default'">
    <template v-slot:main>
      <head-utils title="Pesquisar Comissões"/>
      <breadcrumb :items="[{label: 'Pesquisa de Comissões', path: 'commission_payments'}]"/>

      <form @submit.prevent.stop="submit">
        <ibox>
          <template v-slot:title v-if="!$appUtils.isMobile()">
            <h5>Filtros de Pesquisa</h5>
          </template>

          <template v-slot:content>
            <div v-if="!$appUtils.isMobile() || filterMode" class="container-fluid-grid">
              <div class="form-row">
                <div class="col-3 col-md-1 form-group">
                  <label for="comPaySearchNumber">Número</label>
                  <input id="comPaySearchNumber"
                         maxlength="8"
                         type="text"
                         class="form-control form-control-sm t-r"
                         v-model="search_params.number"/>

                </div>
                <div class="col-9 col-md-2 form-group">
                  <label for="comPaySearchBroker">Corretor</label>
                  <input id="comPaySearchBroker" type="text" class="form-control form-control-sm"
                         v-model="search_params.broker"/>
                </div>
                <div class="col-6 col-md-3 form-group">
                  <label for="comPaySearchSeller">Vendedor</label>
                  <input id="comPaySearchSeller"
                         type="text"
                         class="form-control form-control-sm"
                         v-model="search_params.seller"/>
                </div>
                <div class="col-6 col-md-3 form-group">
                  <label for="comPaySearchBuyer">Comprador</label>
                  <input id="comPaySearchBuyer"
                         type="text"
                         class="form-control form-control-sm"
                         v-model="search_params.buyer"/>
                </div>
                <div class="col-12 col-md-3 form-group">
                  <label for="comPaySearchProduct">Produto</label>
                  <select id="comPaySearchProduct" class="form-control form-control-sm"
                          v-model="search_params.product_id">
                    <option :value="''">[SELECIONE]</option>
                    <optgroup v-for="c in categories" :label="c.name">
                      <option v-for="p in products"
                              v-if="p.product_category_id === c.id"
                              :key="p.id"
                              :value="p.id">{{ p.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>
              <div class="form-row">
                <div class="col-6 col-md-2 form-group">
                  <label for="comPaySearchCreatedStart">Criado entre</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="comPaySearchCreatedStart"
                           v-model="search_params.created_start"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-2 form-group">
                  <label for="comPaySearchCreatedEnd">&nbsp;</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="comPaySearchCreatedEnd"
                           v-model="search_params.created_end"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-2 form-group">
                  <label for="comPaySearchPaidStart">Pago entre</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="comPaySearchPaidStart"
                           v-model="search_params.paid_start"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-2 form-group">
                  <label for="comPaySearchPaidEnd">&nbsp;</label>
                  <div class="input-group input-group-sm">
                    <input type="text"
                           id="comPaySearchPaidEnd"
                           v-model="search_params.paid_end"
                           placeholder="DD/MM/AAAA"
                           v-flatpickr
                           class="form-control form-control-sm t-c plch-center n-m-r-right">
                    <div class="input-group-append">
                      <div class="input-group-text">
                        <svg-icon icon="calendar-alt"/>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="$appUtils.isMobile() && !filterMode">
              <div class="list-card" v-for="fm in search.entries" @click="selectCommission(fm)" :key="fm.id">
                <span class="ident ellipsis f-w-700">{{ fm.identifier }}</span>
                <span class="broker ellipsis t-r f-w-700">{{ fm.broker.name }}</span>

                <span class="emit">
                                    Emissão<br>
                                    {{ fm.emitted_at | formatDate }}
                                </span>
                <span class="paid t-c">
                                    Pagamento<br>
                                    {{ fm.paid_at | formatDate }}
                                </span>
                <span class="value t-r f-w-700 c-theme">
                                    Valor<br>
                                    {{ fm.calculated_total | formatMoney }}
                                </span>

                <div class="tag-container">
                  <router-link :to="`/proposals/${p.id}/edit`"
                               :title="`Vendedor: ${search.customers[p.seller_id]}\nComprador: ${search.customers[p.buyer_id]}\nProduto: ${search.products[p.product_id]}`"
                               :class="p.class"
                               v-for="(p,idx) in fm.proposals"
                               :key="`${idx}${p.number}`">{{ p.number }}
                  </router-link>
                </div>
              </div>
            </div>

            <div v-if="$appUtils.isMobile()">
              <FabMenuCrud :is-open="!filterMode && isOpenFabMenu"
                           url-new="/commission_payments/new"
                           v-if="!filterMode"
                           bottom-pixels="40px"
                           @onExpand="isOpenFabMenu = !isOpenFabMenu"
                           @onFilter="(is) => {
                                         filterMode = is;
                                         isOpenFabMenu = false;
                                         }"/>

              <div ref='end_grid' class="t-c">
                <svg-icon v-if="searching" icon="sync" class="refresh load-more-crud"/>
              </div>
            </div>
          </template>

          <template v-slot:footer>
            <div class="row" v-if="filterMode || !$appUtils.isMobile()">
              <div class="col-sm-12 t-r">
                            <span class="btn-group btn-group-sm" role="group" aria-label="Comandos de Pesquisa">
                                    <button type="button" @click="reset" class="btn btn-secondary btn-sm"><svg-icon
                                        icon="sync"/> Limpar</button>
                                    <router-link to="/commission_payments/new" class="btn btn-dark btn-sm"><svg-icon
                                        icon="plus"/> Criar Novo</router-link>
                                    <button type="submit" class="btn btn-theme-1 btn-sm"><svg-icon icon="search"/> Pesquisar</button>
                                </span>
              </div>
            </div>
            <div class="row" v-if="$appUtils.isDesktop()">
              <div class="col-sm-12">
                <br/>
                <Pagination
                    :page_size="search.per_page"
                    :current_page="search.current_page"
                    :total_entries="search.total_entries"/>


                <Loading :visible="searching"/>
                <table class="table table-hover table-striped table-sm table-bordered">
                  <thead class="thead-dark thead-center">
                  <tr>
                    <th style="width: 150px">
                      <input type="search" v-model="entriesFilter.identifier"
                             class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c"
                             placeholder="Identificador">
                    </th>
                    <th style="width: 150px">
                      <input type="search" v-model="entriesFilter.broker"
                             class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c"
                             placeholder="Corretor">
                    </th>
                    <th>
                      <input type="search" v-model="entriesFilter.proposal"
                             class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c"
                             placeholder="contratos">
                    </th>
                    <th style="width: 110px">
                      <input type="search" v-model="entriesFilter.emitted_at"
                             class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c"
                             placeholder="EMISSÃO">
                    </th>
                    <th style="width: 110px">
                      <input type="search" v-model="entriesFilter.paid_at"
                             class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c"
                             placeholder="PAGAMENTO">
                    </th>
                    <th style="width: 110px">
                      <input type="search" v-model="entriesFilter.value"
                             class="ipt-transp plch-center w-all not-outline plch-c-w t-t-u c-w t-c"
                             placeholder="VALOR">
                    </th>
                  </tr>
                  </thead>
                  <tbody v-if="search && search.entries">
                  <tr v-for="fm in filteredEntries" :key="fm.id" v-if="!searching">
                    <td class="v-m c-p ellipsis" @click="selectCommission(fm)">{{ fm.identifier }}</td>
                    <td class="v-m c-p ellipsis" @click="selectCommission(fm)">{{ fm.broker.name }}</td>
                    <td class="v-m c-p">
                      <div class="tag-container">
                        <router-link :to="`/proposals/${p.id}/edit`"
                                     :title="`Vendedor: ${search.customers[p.seller_id]}\nComprador: ${search.customers[p.buyer_id]}\nProduto: ${search.products[p.product_id]}`"
                                     :class="p.class"
                                     v-for="(p,idx) in fm.proposals"
                                     :key="`${idx}${p.number}`">{{ p.number }}
                        </router-link>
                      </div>
                    </td>
                    <td class="v-m c-p t-c" @click="selectCommission(fm)">{{ fm.emitted_at | formatDate }}</td>
                    <td class="v-m c-p t-c" @click="selectCommission(fm)">{{ fm.paid_at | formatDate }}</td>
                    <td class="v-m c-p t-r f-w-700" @click="selectCommission(fm)">
                      {{ fm.calculated_total | formatMoney }}
                    </td>
                  </tr>
                  </tbody>
                </table>

                <Pagination
                    :page_size="search.per_page"
                    :current_page="search.current_page"
                    :total_entries="search.total_entries"/>
              </div>
            </div>
          </template>
        </ibox>

      </form>
    </template>
  </DefaultTmpl>
</template>

<script>
import Pagination from "../../components/Pagination";
import CRUDSearch from '@/mixins/CRUDSearch'
import FabMenuCrud from "../../components/particles/FabMenuCrud";
import {createNamespacedHelpers} from 'vuex'
import Loading from "../../components/particles/Loading";
import {EventBus} from "../../utils/EventBus";

const {mapGetters, mapActions} = createNamespacedHelpers('products');

export default {
  name: "CommissionPaymentsSearch",
  components: {
    Pagination,
    FabMenuCrud,
    Loading
  },
  mixins: [
    CRUDSearch.mount('commission_payments')
  ],
  data() {
    return {
      filterMode: false,
      isOpenFabMenu: false,
      entriesFilter: {
        identifier: ''
      },
      entries: []
    }
  },
  methods: {
    ...mapActions(['loadAll', 'loadCategories']),
    createSearchParams() {
      return {
        number: '',
        product_id: '',
        broker: '',
        seller: '',
        buyer: '',
        created_start: '',
        created_end: '',
        paid_start: '',
        paid_end: '',
      }
    },
    onFilterSuccess(data) {
      if (this.$appUtils.isDesktop())
        this.entries = JSON.parse(JSON.stringify(data.entries));
    },
    getIntersectItemListener() {
      return this.$refs.end_grid
    },
    selectCommission(fm) {
      const entity = {
        id: fm.id,
        broker_id: fm.broker_id
      };

      EventBus.showFinMov(() => {
      }, {
        entity: entity
      })
    }
  },
  computed: {
    ...mapGetters({products: 'all', categories: 'categories'}),
    filteredEntries() {
      const filter = [];

      this.entries.forEach(fm => {
        if (fm.proposals) fm.proposals.forEach(p => this.$set(p, 'class', null));

        const paidAtCriteria = this.$appUtils.isEmpty(this.entriesFilter.paid_at) || this.$appUtils.formatDate(fm.paid_at).indexOf(this.entriesFilter.paid_at) > -1;
        const emittedAtCriteria = this.$appUtils.isEmpty(this.entriesFilter.emitted_at) || this.$appUtils.formatDate(fm.emitted_at).indexOf(this.entriesFilter.emitted_at) > -1;
        const identifierCriteria = (fm.identifier || '').containsStr(this.entriesFilter.identifier);
        const valueCriteria = (fm.value || '').containsStr(this.entriesFilter.value);

        const propStr = (this.entriesFilter.proposal || '').toLowerCase();

        const brokerCriteria = this.$appUtils.isEmpty(propStr) || fm.proposals.filter(p => {
          const is = (p.number + '').indexOf(this.entriesFilter.proposal) > -1 ||
              this.search.customers[p.buyer_id].toLowerCase().indexOf(propStr) > -1 ||
              this.search.customers[p.seller_id].toLowerCase().indexOf(propStr) > -1 ||
              this.search.products[p.product_id].toLowerCase().indexOf(propStr) > -1;
          this.$set(p, 'class', is ? 'spotlight' : null);
          return is
        }).length > 0;

        const proposalsCriteria = (fm.broker.name || '').containsStr(this.entriesFilter.broker);

        if (fm.proposals) {
          fm.proposals.sort((a, b) => {
            if (a.class && b.class) return a.number - b.number;
            else if (a.class) return -1;

            return 0
          });
        }

        if (identifierCriteria && paidAtCriteria && brokerCriteria && proposalsCriteria && emittedAtCriteria && valueCriteria) {
          filter.push(fm);
        }
      });

      return filter;
    }
  },
  created() {
    this.loadCategories();
    this.loadAll();
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/css/scrollbar";
@import "../../assets/css/variables";

.tag-container {
  width: 100%;
  max-width: 100%;
  max-height: 22px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  overflow-x: auto;
  font-weight: 400;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  a {
    background-color: $theme_color_eight;
    color: #fff;
    display: inline-block;
    max-height: 22px;
    border-radius: 5px;
    padding-left: 5px;
    padding-right: 5px;
    white-space: nowrap;
    cursor: pointer;
    text-decoration: none;
    transition: background-color .3s ease;

    &:hover {
      background-color: $theme_color_three;
    }

    &:not(:first-child) {
      margin-left: 5px;
    }

    &.spotlight {
      animation: spotlightAnim 1s linear infinite;
    }
  }
}

.list-card {
  display: grid;
  width: 100%;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto;
  grid-template-areas: "ident ident broker"  "emit paid value" "prop prop prop";
  grid-gap: 5px;
  font-size: .8em;
  padding: 5px;

  &:not(:first-child) {
    border-top: 1px solid #e7eaec;
  }


  .ident {
    grid-area: ident
  }

  .broker {
    grid-area: broker
  }

  .emit {
    grid-area: emit
  }

  .paid {
    grid-area: paid
  }

  .value {
    grid-area: value
  }

  .tag-container {
    grid-area: prop;
  }
}

@keyframes spotlightAnim {
  0% {
    background-color: $theme_color_one;
  }
  50% {
    background-color: $theme_color_three;
  }
  100% {
    background-color: $theme_color_one;
  }
}
</style>
